module.exports = __webpack_public_path__ + "static/media/Logotipo-SAPTalent-original.6336ab09.svg";